<template>
  <section class="tableWrap">
    <div class="fieldWrap">
      <div class="fieldBx">
        <ul>
          <li class="formList">
            <dl>
              <dd>
                <v-select :items="flagItems"
                          v-model="searchActivated"
                          label="사용여부"
                          item-text="text"
                          item-value="value"
                          v-on:change="getList"
                          dense outlined clearable flat
                />
              </dd>
            </dl>
            <dl>
              <dd>
                <v-select :items="flagItems"
                          v-model="searchProtected"
                          label="접근제어"
                          item-text="text"
                          item-value="value"
                          v-on:change="getList"
                          dense outlined clearable flat
                />
              </dd>
            </dl>
            <dl>
              <dd>
                <v-select :items="requestTypes"
                          v-model="searchType"
                          label="Request Type"
                          item-text="value"
                          item-value="text"
                          v-on:change="getList"
                          dense outlined clearable flat
                />
              </dd>
            </dl>
            <dl>
              <dd>
                <v-col class="mgr" sm="3">
                  <v-text-field v-model="searchValue" v-on:keyup.enter="getList" label="url / 이름 검색" outlined dense flat clearable/>
                </v-col>
              </dd>
            </dl>
            <dl>
              <dd>
                <div class="searchBtn">
<!--                  <v-btn color="#424964" depressed dark @click="getList">검색</v-btn>-->
                </div>
              </dd>
            </dl>
          </li>
        </ul>
      </div>

    </div>
<!--    v-model="selectedRows"-->
    <div class="tabContentBx">
      <div class="tabContent">
        <div class="tableBx">
          <v-data-table
              ref="endpointTable"
              v-model="onRow"
              :hide-default-footer="false"
              :headers="header"
              :items="datas"
              class="elevation-1"
              :items-per-page="10"
              :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options' : [10,20,50,100]
                    }"
              :options.sync="options"
              :loading="loading"
              :server-items-length="totalDesserts"
              :show-select="endpointShowSelect"
              item-key="itemKey"
              disable-sort
          >
            <template v-slot:item.data-table-select="{ isSelected, item }">
<!--              <v-simple-checkbox v-model="onRow" :value="item" @change="check(isSelected, item)"></v-simple-checkbox>-->
              <v-checkbox v-model="onRow" :value="item" style="margin-left:8px; margin-top:0;padding:0" hide-details color="gray" v-if="item.protected"/>
<!--              <v-checkbox v-model="onRow" :value="item"></v-checkbox>-->
            </template>

<!--            <template v-slot:item.data-table-select="{ item }">-->
<!--              <v-checkbox v-model="onRow" :value="item"></v-checkbox>-->
<!--            </template>-->
            <!--                  :search="searchValue"-->
<!--            <template v-slot:item.isSelected="{ item }">-->
<!--              <v-checkbox v-model="item.isSelected" @change="setMapping(item)" v-if="searchRoleId"></v-checkbox>-->
<!--            </template>-->

            <template v-slot:item.createdAt="{ item }">
              {{$moment(item.createdAt).format('YYYY.MM.DD HH:mm:ss')}}
            </template>
            <template v-slot:item.state="{ item }">
              <v-icon left v-if="item.state === 'disable'">mdi mdi-circle</v-icon>
              <v-icon left color="primary" v-else-if="item.state === 'enable'">mdi mdi-checkbox-marked-circle</v-icon>
              <v-icon left color="red" v-else-if="item.state === 'block'">mdi-cancel</v-icon>
              <v-icon left v-else>mdi mdi-circle</v-icon>
              <!--                    {{ stateItems.filter(s => s.code === item.state ).map(s => s.code_name)[0] }}-->
            </template>

            <template v-slot:item.activated="{item}">
              {{item.activated ? '사용' : '사용안함'}}
            </template>
            <template v-slot:item.protected="{item}">
              {{item.protected ? '사용' : '사용안함'}}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                  small
                  class="mr-2"
                  @click.stop="updateEndpointForm(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                  small
                  @click.stop="deleteEndpoint(item)"
              >
                mdi-delete
              </v-icon>
            </template>

          </v-data-table>

          <endpoint-form
              :is-visible="dialogVisible"
              :item="menu"
              :role-key="searchRoleId"
              @callback-cancel="dialogVisible = false"
              @callback-saved="savedEndpoint"
          />

          <div class="btnStyleBx">
            <div class="btnCommon justify-center tableBtn">

              <ul>
                <li class="tableBtnList">
                  <v-btn class="vIconResize" @click="setMapping">
                    <v-icon left>mdi mdi-link</v-icon> Role Mapping
                  </v-btn>
                </li>
                <li class="tableBtnList">
                  <v-btn class="vIconResize" @click="createEndpointForm">
                    <v-icon left>mdi mdi-playlist-plus</v-icon> Endpoint 추가
                  </v-btn>
                </li>

              </ul>


            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import endpointApi from "@/api/EndpointApi";
import roleApi from "@/api/RoleApi";

import EndpointForm from "@/views/role/component/EndpointForm";

import _ from 'lodash';
// import codeApi from "@/api/code";

export default {
  name: "EndpointList",
  components: {
    'endpoint-form': EndpointForm
  },
  props: {
    role: Object
  },
  data: () => ({
    header:[
      {
        text: 'Endpoint',
        value: 'id.endpointUrl',
        align: 'left',
        sortable: false
      },
      {
        text:'Request Type',
        value:'id.requestType',
        align: 'left',
        sortable: false
      },
      {
        text: '이름',
        value: 'endpointName',
        align: 'left',
        sortable: false
      },
      {
        text: '생성일',
        value: 'createdAt',
        align: 'center',
        sortable: false
      },
      {
        text: '접근제어',
        value: 'protected',
        align: 'center',
        sortable: false
      },
      {
        text: '사용여부',
        value: 'activated',
        align: 'center',
        sortable: false
      },
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    menu: {},
    dialogVisible: false,
    datas: [],
    totalDesserts: 0,
    loading:true,
    options:{},
    endpointShowSelect:false,
    onRow:[],
    pagination: {
      sortBy: 'createdAt',
      rowsPerPage: 10
    },
    requestTypes: ['ANY', 'GET', 'POST', 'PUT', 'DELETE'],
    flagItems: [
      {
        value: true,
        text: '사용'
      },
      {
        value: false,
        text: '사용안함'
      }
    ],
    searchValue : '',
    searchActivated:null,
    searchProtected:null,
    searchType:null,
    searchRoleId:null,
    mappings: [],
    waitingSearch:false
  }),
  computed: {
    selectedRows: {
      get() {
        return this.onRow.filter(r => r.protected)
      },
      // set(v) {
        // console.log("-----------1")
        // console.log(v);
        // console.log("-----------2")
        // this.onRow = v.filter(r => r.protected);
      // }
    }
  },
  watch: {
    options: {
      handler () {
        this.getList();
      },
      deep: true,
    },
    searchValue: {
      handler() {
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.getList();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
    role: {
      handler(nv) {
        // this.onRow = [];
        this.searchRoleId = nv.roleId;
        if(nv.roleId) {
          this.getRoleHasEndpoints();
        } else {
          this.endpointShowSelect = false;
          this.searchRoleId = null;
          this.onRow = [];
          // this.getList();
        }
        // this.mappings
      }
    }
  },
  methods: {
    createEndpointForm() {
      this.menu = {id:{}};
      this.dialogVisible = true;
    },
    updateEndpointForm(item) {
      this.menu = _.cloneDeep(item);
      this.dialogVisible = true;
    },
    savedEndpoint(item) {
      if(!this.datas || this.datas.length < 1) {
        this.datas = [];
      }

      const legacy = this.datas.filter(d => d.id.endpointUrl === item.id.endpointUrl && d.id.requestType === item.id.requestType)?.[0]??'';
      const idx = this.datas.indexOf(legacy);

      if(idx >= 0) {
        this.datas[idx] = Object.assign(this.datas[idx], item);
      } else {
        this.getList();
        // if(this.datas.length === 0)
        //   this.datas.push(item);
        // else
        //   this.datas.unshift(item);

        // this.datas.push(item);
      }
      this.dialogVisible = false;
    },
    deleteEndpoint(item) {
      if(confirm('삭제하시겠습니까?')) {
        endpointApi.deleteEndpoint(item.id.endpointUrl, item.id.requestType).then(() => {
          this.getList();
          // this.datas = this.datas.filter(d => d.menu !== item.menu && d.request_type !== item.request_type);
        });
      }
    },
    getList() {
      this.loading = true
      // const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const { page, itemsPerPage } = this.options

      this.loading = false;
      const param = {
        size:itemsPerPage,
        page,
        searchValue : this.searchValue,
        searchActivated : this.searchActivated,
        searchProtected : this.searchProtected,
        searchType : this.searchType
      }
      endpointApi.getList(param).then(data => {
        // this.datas = data.items;
        // console.log(data);
        this.datas = data.content.map(d => Object.assign(d, {itemKey:d.id.requestType +"_"+ d.id.endpointUrl}));
        this.totalDesserts = data.totalElements;
      });
    },
    getRoleHasEndpoints() {
      this.endpointShowSelect = true;
      roleApi.getEndpoints(this.searchRoleId).then(result => {
        // console.log(result);
        // console.log(nv.roleId);
        // this.mappings = result.map(m => m.menu);

        this.onRow = this.datas.filter(d => result.map(r => r.id.requestType + "_" + r.id.endpointUrl).indexOf(d.id.requestType + "_" + d.id.endpointUrl) !== -1);
        // console.log(this.onRow)
        // this.onRow = result.map(d => Object.assign({itemKey:d.id.requestType + "_" + d.id.endpointUrl}, {id:d.id}));

        // console.log(this.onRow);

        // this.datas = this.datas.map(d => {
        //   // if(this.mappings.includes(d.menu)) {
        //   if(result.some(r => r.id.endpointUrl === d.id.endpointUrl && r.id.requestType === d.id.requestType)) {
        //     Object.assign(d, {isSelected:true, itemKey:(d.id.requestType + d.id.endpointUrl)});
        //     // d.isSelected = true;
        //   } else {
        //     Object.assign(d, {isSelected:false, itemKey:(d.id.requestType + d.id.endpointUrl)});
        //   }
        //
        //   return d;
        // });

      });
    },
    setMapping() {
      if(!this.searchRoleId) {
        alert("역할을 선택해주세요.");
        return false;
      }
      let postDatas = _.cloneDeep(this.onRow.filter(r => r.protected)).map(r => Object.assign(r.id, {roleId:this.searchRoleId}));
      // console.log(postDatas);
      roleApi.mappingEndpoints(this.searchRoleId, postDatas).then(() => {
        alert('저장되었습니다.');
      });
    },
    // check(selected, item) {
    //   console.log(selected)
    //   console.log(item)
    // }
  },
  created() {
    // codeApi.getCode("ENDPOINT_STATE").then(data => {
    //   this.states = data.child;
    // });
    this.searchRoleId = this.role?.roleId??null;
    if(this.searchRoleId)
      this.getRoleHasEndpoints();
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    //width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
.amountBx {
  display: flex;
  align-items: center;
  height: 35px;
  border-radius: 3px;
  border: 1px solid #1867c0;
  margin-top: 13px;

  .amount {
    &:first-child {
      padding-left: 10px;
    }

    height: 100%;
    padding: 0 8px;
    border: 0;
    background: #fff;
    font-size: 13px;
    font-weight: normal;
    color: #1867c0;

    &.active {
      background: #1867c0;
      color: #fff;
    }
  }
}
</style>